import { useLocation, Navigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { selectSsoStatus, selectUser } from "features/userSlice";
import { getCookie } from "./cookies";

const SSO_COOKIE = "xbadm_session";

const RequireAuth = ({ children }) => {
  const user = useSelector(selectUser);
  const ssoStatus = useSelector(selectSsoStatus);
  const location = useLocation();

  const isLogout = location.state?.logout ?? false;
  const hasSession = Boolean(getCookie(SSO_COOKIE));

  if (isLogout) {
    return <Navigate to="/" />;
  }

  if (user) {
    return children;
  }

  if (hasSession && (ssoStatus === "idle" || ssoStatus === "checking")) {
    return null;
  }

  return <Navigate to="/login" state={{ from: location }} />;
};

export default RequireAuth;
